import type { Nullable } from '@ats/interfaces';
import useElementAspectRatio from '@hooks/ref/useElementAspectRatio';
import type { FC, HTMLAttributes, PropsWithChildren } from 'react';
import React, { createContext, createRef } from 'react';
import { Container } from './style';

export interface VideoGridProps extends HTMLAttributes<HTMLDivElement> {
  shared?: boolean;
}

interface GridContext {
  usingGrid: boolean;
}

const gridData = { usingGrid: true };
const GridContext = createContext<Nullable<GridContext>>(null);

export const VideoGrid: FC<PropsWithChildren<VideoGridProps>> = ({
  shared,
  children,
  ...rest
}) => {
  const gridEl = createRef<HTMLDivElement>();
  const ratio = useElementAspectRatio(gridEl);
  const gridSize = React.Children.count(children);

  return (
    <GridContext.Provider value={gridData}>
      <Container
        ref={gridEl}
        {...rest}
        size={gridSize}
        ratio={ratio}
        featured={false}
        shared={shared}
        data-testid='video-grid'
      >
        {children}
      </Container>
    </GridContext.Provider>
  );
};

export default VideoGrid;
